// ESM-Modul fuer den QR-Code auf dem Beleg (frueher
// lib/scripts/pos/receipt/CLS_CQRCode.js - die LETZTE Anwendungsdatei
// ausserhalb des Buendels; sie stand nicht im Manifest, sondern wurde zur
// Laufzeit ueber den hauseigenen require()-Ersatz aus main-fnc.js geladen).
//
// RKSV-RELEVANT: QRCodePOSCommand() liefert die ESC/POS-Bytes des QR-Codes,
// der auf dem Beleg gedruckt wird. Originalquelltext unveraendert; geaendert
// sind nur:
//   1. module.exports -> ESM-Export,
//   2. "var" vor wL und hL (siehe unten).
//
// Zu 2.: wL/hL waren UNDEKLARIERT und legten im nicht-strikten Modus je eine
// Globale an. ES-Module sind immer strikt - dort waere daraus ein
// ReferenceError geworden, und zwar mitten im Bau des Rasterkopfes (Byte 4
// und 6 des Druckpuffers). Dieselbe Fallenklasse wie beim CRunClient-Port
// einen Commit zuvor; hier VOR dem Verschieben gesucht, nicht danach.
// Die beiden Globalen liest ausserhalb dieser Datei niemand (geprueft).

function QRCodeFactory(_qrOptions) {

    //function QRCode(_qrOptions) {
    if (_qrOptions.width) {
        this.initwidth = _qrOptions.width;
    } else {
        this.initwidth = 200;
    }
    if (_qrOptions.heigth) {
        this.initheight = _qrOptions.heigth;
    } else {
        this.initheight = 200;
    }
    if (_qrOptions.scaleX) {
        this.scaleX = _qrOptions.scaleX;
    } else {
        this.scaleX = 0.8;
    }
    if (_qrOptions.scaleY) {
        this.scaleY = _qrOptions.scaleY;
    } else {
        this.scaleY = 0.6;
    }
    this.document = _qrOptions.doc;
    this.qrcodediv = null;

    //}

    QRCodeFactory.prototype.QRCodePOSCommand = function($, text) {

        return this.QRCodeToPOS(this.appendQRCodeImage($, text));

    }

    QRCodeFactory.prototype.appendQRCodeImage = function($, text, width, height, div) { //"_R1-AT0_DEMO-CASH-BOX473_123456_2016-01-12T16:42:34_0,00_0,00_0,00_0,00_0,00_ozTcIVfY/Tc=_5633631506111725924_gYzzqvCq84U="


        if (!div) {
            div = this.document.createElement("div");
        }
        div.setAttribute("id", "qrcode");
        if (!width) {
            width = this.initwidth;
        }
        if (!height) {
            height = this.initheight;
        }

        $(div).qrcode({
            text: text,
            size: width,
						ecLevel: 'M'  //L,M,Q,H
        });
        this.qrcodediv = div;
        return div;
    }

    QRCodeFactory.prototype.QRCodeToPOS = function(d) {
        var self = this;
        var canvas = d.childNodes[0];
        var context = canvas.getContext('2d');
        var imgd = context.getImageData(0, 0, this.initwidth, this.initheight);
        //$("#applicationArea").append(d);
//        imgd = self.scaleImageData(context, imgd, this.scaleX, this.scaleY);
        //  var pix = imgd.data;


        //pixel to image

        var data = [];

        function rgb(pixel) {
            return {
                r: pixel[0],
                g: pixel[1],
                b: pixel[2],
                a: pixel[3]
            };
        };
        var colors = 4;
        for (var i = 0; i < imgd.data.length; i += colors) {
            var arr = new Array(colors);
            for (var x = 0; x < 4; x++) {
                arr[x] = 0;
            }
            //.fill(0);
            var arr2 = rgb(arr.map(function(_, b) {
                return imgd.data[i + b];
            }));
            data.push(arr2);
        };

        data = data.map(function(pixel) {
            if (pixel.a == 0) return 0;
            return pixel.r !== 0xFF || pixel.g !== 0xFF || pixel.b !== 0xFF ? 1 : 0;
        });


        /////////////



        var toRaster = function(data) {
            var result = [];
            var width = imgd.width;
            var height = imgd.height;
            //var data = data;

            // n blocks of lines
            var n = Math.ceil(width / 8);
            var x, y, b, c, i;

            for (y = 0; y < height; y++) {

                for (x = 0; x < n; x++) {

                    for (b = 0; b < 8; b++) {
                        i = x * 8 + b;

                        if (result[y * n + x] === undefined) {
                            result[y * n + x] = 0;
                        }

                        c = x * 8 + b;
                        if (c < width) {
                            if (data[y * width + i]) {
                                result[y * n + x] += (0x80 >> (b & 0x7));
                            }
                        }
                    }
                }
            }
            return {
                data: result,
                width: n,
                height: height
            };
        }

        //////////////////
        var mode = mode || 'normal';
        if (mode === 'dhdw' ||
            mode === 'dwh' ||
            mode === 'dhw') mode = 'dwdh';
        var raster = toRaster(data);
        /*
        				var options = options || {
                    type: 'png',
                    mode: 'dhdw'
                };
        */



        var wH = Math.floor(raster.width / 256);
        if (wH > 3) {
            alert("qrcode image zu gross!!");
        }
        var wL = raster.width - wH * 256;
        var hH = Math.floor(raster.height / 256);
        if (hH > 3) {
            alert("qrcode image zu gross!!");
        }
        var hL = raster.height - hH * 256;


        var buffer = new Buffer(raster.data.length + 8);
        //    var header = self.GSV0_FORMAT['GSV0_' + mode.toUpperCase()];
        //    buffer.write(header); \x1d\x76\x30\x03
        buffer[0] = 0x1D;
        buffer[1] = 0x76;
        buffer[2] = 0x30;
        buffer[3] = 0x00;
        buffer[4] = wL;
        buffer[5] = wH;
        buffer[6] = hL;
        buffer[7] = hH;
        /*
                buffer.writeUInt16LE(raster.width);
                buffer.writeUInt16LE(raster.height);*/
        for (var i = 0; i < raster.data.length; i++) {
            buffer[i + 8] = raster.data[i];
        }
        return buffer;

        ///////////////////////////////





        var heightinit = this.scaleY * this.initheight;
        var width = this.scaleX * this.initwidth;

        var bitcount = 8;
        var pixel = 0; // 0= weiss, 1 = schwarz
        var ebenen = 4;
        var height = Math.ceil(heightinit / bitcount) * bitcount;

        var nrpixels = width * height; //width x height


        var pixelbuffer = new Buffer(nrpixels);

        var pointer = 0;

        for (i = 0; i < nrpixels; i++) {
            pixel = 0; //schwarz
            pointer = i * ebenen;
            if (pointer < pix.length) {
                //for (j = 0; j < 3; j++) { //nur RGB
                //pixel = pixel || pix[pointer + j];
                if (pix[pointer + ebenen - 1] < 129) {
                    pixel = 1;
                } else {
                    pixel = 0;
                }
                //}
            } else {
                pixel = 1; //weiss
            }
            if (pixel > 0) {
                pixelbuffer[i] = 0; //weiss
            } else {
                pixelbuffer[i] = 1; //schwarz
            }
        }

        var nL = 0;
        var nH = 0;
        var m = 0; //


        nH = Math.floor(width / 256);
        if (nH > 3) {
            alert("qrcode image zu gross!!");
        }
        nL = width - nH * 256;

        var nrrows = Math.ceil(height / bitcount); //height

        var prependedchars = 12;
        var appendchars = 1;
        var colarray = new Buffer(width + prependedchars + appendchars); //width
        var commandbuffer = new Buffer(nrrows * colarray.length + 5);
        var pixelrow = 0;
        var rownr = 0;
        var position = 3;
        //init
        commandbuffer[0] = 0x1B;
        commandbuffer[1] = 0x40;
        //line feed
        commandbuffer[2] = 0x0A;
        //	position++;

        for (x = 0; x < nrpixels; x = x + (width * bitcount)) {
            //absolute position
            colarray[0] = 0x1B;
            colarray[1] = 0x61;
            colarray[2] = 49; // nL
            colarray[3] = 1; //n
            // tab
            //colarray[3] = 0x9;
            //set line spacing
            colarray[4] = 0x1B;
            colarray[5] = 0x33;
            colarray[6] = 0; //0 pixel
            //
            colarray[7] = 0x1B;
            colarray[8] = 0x2A;
            colarray[9] = m;
            colarray[10] = nL;
            colarray[11] = nH;

            for (pixelrow = 0; pixelrow < bitcount; pixelrow++) {
                for (y = 0; y < width; y++) { //width
                    //Math.pow(pixelrow,2);
                    colarray[y + prependedchars] = colarray[y + prependedchars] << 1;
                    if (pixelbuffer[x + y + pixelrow * width] > 0) {
                        colarray[y + prependedchars] = colarray[y + prependedchars] + 1;
                    }
                }
            }
            colarray[width + prependedchars] = 0x0A;
            //pixelrow++;

            //if (pixelrow == 8) {
            pixelrow = 0;
            for (z = 0; z < colarray.length; z++) {
                commandbuffer[position] = colarray[z];
                position++;
            }
            colarray = new Array(width + prependedchars + appendchars);
            rownr++;
            //}

        }
        commandbuffer[nrrows * colarray.length + 3] = 0x1B;
        commandbuffer[nrrows * colarray.length + 4] = 0x40;
        return commandbuffer;

    }

    QRCodeFactory.prototype.scaleImageData2 = function(c, imageData, scaleX, scaleY) {
        //c.scale(0.8, 0.4);
        //c.drawImage(

    }

    QRCodeFactory.prototype.scaleImageData = function(c, imageData, scaleX, scaleY) {
        var scaled = c.createImageData(imageData.width * scaleX, imageData.height * scaleY);

        for (var row = 0; row < imageData.height; row++) {
            for (var col = 0; col < imageData.width; col++) {
                var sourcePixel = [
                    imageData.data[(row * imageData.width + col) * 4 + 0],
                    imageData.data[(row * imageData.width + col) * 4 + 1],
                    imageData.data[(row * imageData.width + col) * 4 + 2],
                    imageData.data[(row * imageData.width + col) * 4 + 3]
                ];
                for (var y = 0; y < scaleY; y++) {
                    var destRow = parseInt(row * scaleY) + y;
                    for (var x = 0; x < scaleX; x++) {
                        var destCol = parseInt(col * scaleX) + x;
                        for (var i = 0; i < 4; i++) {
                            scaled.data[(destRow * scaled.width + destCol) * 4 + i] =
                                sourcePixel[i];
                        }
                    }
                }
            }
        }

        return scaled;
    }

}

QRCodeFactory.prototype.com = {
    LF: '\x0a',
    FS: '\x1c',
    FF: '\x0c',
    GS: '\x1d',
    DLE: '\x10',
    EOT: '\x04',
    NUL: '\x00',
    ESC: '\x1b',
    EOL: '\n'
};


/**
 * [FEED_CONTROL_SEQUENCES Feed control sequences]
 * @type {Object}
 */
QRCodeFactory.prototype.FEED_CONTROL_SEQUENCES = {
    CTL_LF: '\x0a', // Print and line feed
    CTL_FF: '\x0c', // Form feed
    CTL_CR: '\x0d', // Carriage return
    CTL_HT: '\x09', // Horizontal tab
    CTL_VT: '\x0b', // Vertical tab
};

QRCodeFactory.prototype.LINE_SPACING = {
    LS_DEFAULT: '\x1b\x32',
    LS_SET: '\x1b\x33'
};

/**
 * [HARDWARE Printer hardware]
 * @type {Object}
 */
QRCodeFactory.prototype.HARDWARE = {
    HW_INIT: '\x1b\x40', // Clear data in buffer and reset modes
    HW_SELECT: '\x1b\x3d\x01', // Printer select
    HW_RESET: '\x1b\x3f\x0a\x00', // Reset printer hardware
};

/**
 * [CASH_DRAWER Cash Drawer]
 * @type {Object}
 */
QRCodeFactory.prototype.CASH_DRAWER = {
    CD_KICK_2: '\x1b\x70\x00', // Sends a pulse to pin 2 []
    CD_KICK_5: '\x1b\x70\x01', // Sends a pulse to pin 5 []
};

/**
 * [MARGINS Margins sizes]
 * @type {Object}
 */
QRCodeFactory.prototype.MARGINS = {
    BOTTOM: '\x1b\x4f', // Fix bottom size
    LEFT: '\x1b\x6c', // Fix left size
    RIGHT: '\x1b\x51', // Fix right size
};

/**
 * [PAPER Paper]
 * @type {Object}
 */
QRCodeFactory.prototype.PAPER = {
    PAPER_FULL_CUT: '\x1d\x56\x00', // Full cut paper
    PAPER_PART_CUT: '\x1d\x56\x01', // Partial cut paper
    PAPER_CUT_A: '\x1d\x56\x41', // Partial cut paper
    PAPER_CUT_B: '\x1d\x56\x42', // Partial cut paper
};

/**
 * [TEXT_FORMAT Text format]
 * @type {Object}
 */
QRCodeFactory.prototype.TEXT_FORMAT = {

    TXT_NORMAL: '\x1b\x21\x00', // Normal text
    TXT_2HEIGHT: '\x1b\x21\x10', // Double height text
    TXT_2WIDTH: '\x1b\x21\x20', // Double width text
    TXT_4SQUARE: '\x1b\x21\x30', // Double width & height text

    TXT_CUSTOM_SIZE: function(width, height) { // other sizes
        var widthDec = (width - 1) * 16;
        var heightDec = height - 1;
        var sizeDec = widthDec + heightDec;
        return '\x1d\x21' + String.fromCharCode(sizeDec);
    },

    TXT_HEIGHT: {
        1: '\x00',
        2: '\x01',
        3: '\x02',
        4: '\x03',
        5: '\x04',
        6: '\x05',
        7: '\x06',
        8: '\x07'
    },
    TXT_WIDTH: {
        1: '\x00',
        2: '\x10',
        3: '\x20',
        4: '\x30',
        5: '\x40',
        6: '\x50',
        7: '\x60',
        8: '\x70'
    },

    TXT_UNDERL_OFF: '\x1b\x2d\x00', // Underline font OFF
    TXT_UNDERL_ON: '\x1b\x2d\x01', // Underline font 1-dot ON
    TXT_UNDERL2_ON: '\x1b\x2d\x02', // Underline font 2-dot ON
    TXT_BOLD_OFF: '\x1b\x45\x00', // Bold font OFF
    TXT_BOLD_ON: '\x1b\x45\x01', // Bold font ON
    TXT_ITALIC_OFF: '\x1b\x35', // Italic font ON
    TXT_ITALIC_ON: '\x1b\x34', // Italic font ON

    TXT_FONT_A: '\x1b\x4d\x00', // Font type A
    TXT_FONT_B: '\x1b\x4d\x01', // Font type B
    TXT_FONT_C: '\x1b\x4d\x02', // Font type C

    TXT_ALIGN_LT: '\x1b\x61\x00', // Left justification
    TXT_ALIGN_CT: '\x1b\x61\x01', // Centering
    TXT_ALIGN_RT: '\x1b\x61\x02', // Right justification
};

/**
 * Qsprinter-compatible
 * Added by Attawit Kittikrairit
 * [MODEL Model-specific commands]
 * @type {Object}
 */
QRCodeFactory.prototype.MODEL = {
    QSPRINTER: {
        BARCODE_MODE: {
            ON: '\x1d\x45\x43\x01', // Barcode mode on
            OFF: '\x1d\x45\x43\x00', // Barcode mode off
        },
        BARCODE_HEIGHT_DEFAULT: '\x1d\x68\xA2', // Barcode height default:162
        CODE2D_FORMAT: {
            PIXEL_SIZE: {
                CMD: '\x1b\x23\x23\x51\x50\x49\x58',
                MIN: 1,
                MAX: 24,
                DEFAULT: 12,
            },
            VERSION: {
                CMD: '\x1d\x28\x6b\x03\x00\x31\x43',
                MIN: 1,
                MAX: 16,
                DEFAULT: 3,
            },
            LEVEL: {
                CMD: '\x1d\x28\x6b\x03\x00\x31\x45',
                OPTIONS: {
                    L: 48,
                    M: 49,
                    Q: 50,
                    H: 51,
                }
            },
            LEN_OFFSET: 3,
            SAVEBUF: {
                // Format: CMD_P1{LEN_2BYTE}CMD_P2{DATA}
                // DATA Max Length: 256*256 - 3 (65533)
                CMD_P1: '\x1d\x28\x6b',
                CMD_P2: '\x31\x50\x30',
            },
            PRINTBUF: {
                // Format: CMD_P1{LEN_2BYTE}CMD_P2
                CMD_P1: '\x1d\x28\x6b',
                CMD_P2: '\x31\x51\x30',
            }
        },
    },
};

/**
 * [BARCODE_FORMAT Barcode format]
 * @type {Object}
 */
QRCodeFactory.prototype.BARCODE_FORMAT = {
    BARCODE_TXT_OFF: '\x1d\x48\x00', // HRI barcode chars OFF
    BARCODE_TXT_ABV: '\x1d\x48\x01', // HRI barcode chars above
    BARCODE_TXT_BLW: '\x1d\x48\x02', // HRI barcode chars below
    BARCODE_TXT_BTH: '\x1d\x48\x03', // HRI barcode chars both above and below

    BARCODE_FONT_A: '\x1d\x66\x00', // Font type A for HRI barcode chars
    BARCODE_FONT_B: '\x1d\x66\x01', // Font type B for HRI barcode chars

    BARCODE_HEIGHT: function(height) { // Barcode Height [1-255]
        return '\x1d\x68' + String.fromCharCode(height);
    },
    // Barcode Width  [2-6]
    BARCODE_WIDTH: {
        1: '\x1d\x77\x02',
        2: '\x1d\x77\x03',
        3: '\x1d\x77\x04',
        4: '\x1d\x77\x05',
        5: '\x1d\x77\x06',
    },
    BARCODE_HEIGHT_DEFAULT: '\x1d\x68\x64', // Barcode height default:100
    BARCODE_WIDTH_DEFAULT: '\x1d\x77\x01', // Barcode width default:1

    BARCODE_UPC_A: '\x1d\x6b\x00', // Barcode type UPC-A
    BARCODE_UPC_E: '\x1d\x6b\x01', // Barcode type UPC-E
    BARCODE_EAN13: '\x1d\x6b\x02', // Barcode type EAN13
    BARCODE_EAN8: '\x1d\x6b\x03', // Barcode type EAN8
    BARCODE_CODE39: '\x1d\x6b\x04', // Barcode type CODE39
    BARCODE_ITF: '\x1d\x6b\x05', // Barcode type ITF
    BARCODE_NW7: '\x1d\x6b\x06', // Barcode type NW7
    BARCODE_CODE93: '\x1d\x6b\x48', // Barcode type CODE93
    BARCODE_CODE128: '\x1d\x6b\x49', // Barcode type CODE128
};

/**
 * [CODE2D_FORMAT description]
 * @type {Object}
 */
QRCodeFactory.prototype.CODE2D_FORMAT = {
    TYPE_PDF417: '\x1d' + 'Z' + '\x00',
    TYPE_DATAMATRIX: '\x1d' + 'Z' + '\x01',
    TYPE_QR: '\x1d' + 'Z' + '\x02',
    CODE2D: '\x1b' + 'Z',
    QR_LEVEL_L: 'L', // correct level 7%
    QR_LEVEL_M: 'M', // correct level 15%
    QR_LEVEL_Q: 'Q', // correct level 25%
    QR_LEVEL_H: 'H' // correct level 30%
};

/**
 * [IMAGE_FORMAT Image format]
 * @type {Object}
 */
QRCodeFactory.prototype.IMAGE_FORMAT = {
    S_RASTER_N: '\x1d\x76\x30\x00', // Set raster image normal size
    S_RASTER_2W: '\x1d\x76\x30\x01', // Set raster image double width
    S_RASTER_2H: '\x1d\x76\x30\x02', // Set raster image double height
    S_RASTER_Q: '\x1d\x76\x30\x03', // Set raster image quadruple
};

/**
 * [BITMAP_FORMAT description]
 * @type {Object}
 */
QRCodeFactory.prototype.BITMAP_FORMAT = {
    BITMAP_S8: '\x1b\x2a\x00',
    BITMAP_D8: '\x1b\x2a\x01',
    BITMAP_S24: '\x1b\x2a\x20',
    BITMAP_D24: '\x1b\x2a\x21'
};

/**
 * [GSV0_FORMAT description]
 * @type {Object}
 */
QRCodeFactory.prototype.GSV0_FORMAT = {
    GSV0_NORMAL: '\x1d\x76\x30\x00',
    GSV0_DW: '\x1d\x76\x30\x01',
    GSV0_DH: '\x1d\x76\x30\x02',
    GSV0_DWDH: '\x1d\x76\x30\x03'
};



export { QRCodeFactory };
